module.exports = __webpack_public_path__ + "images/application/i-docs-7b49564d.svg";